
/**
 * Class for manipulating time and dates
 */
export default function() {
  
  /////////////////////////////////
  // Data members
  /////////////////////////////////
  var self = this;

  /////////////////////////////////
  // Public Methods
  /////////////////////////////////

  /**
   *  FILLS IN MISSING MONTHS (GAPS) WITH EMPTY VALUES.
   *  
   *  If January KPIs were uploaded, February was skipped, then March was uploaded...
   *  This causes issues with offsets such that "report.month" value if looking at March will still be 
   *  3, but it's offset in the months array will be 1 instead of the expected (i-1) value of 2. 
   *  report.curYear = [
   *      0 => January,
   *      1 => March
   *  ]
   *  
   *  This makes direct reference in the form of 
   *  report.curYear[month][metric.field] crash and burn.
   *  
   *  @requirement The report months MUST be sorted by year, month ascending.
   *  @return void.
   */
  this.fillInEmptyMonths = function(report) {
      // List of KPI reports we are dealing with
      var reportYears = [report.curYear, report.prevYear, report.target];
      
      // For each of the KPI reports
      for (var i = 0, len = reportYears.length; i < len; i++) {

          // If viewing previous year, January starts at 1 (because 0 is Target), otherwise it starts at offset 0
          // var offsetStart = (i == 1) ? 0 : 1;
          var hasTargetEntry = reportYears[i][0] && parseInt(reportYears[i][0].month) === 0;
          var offsetStart = hasTargetEntry ? 0 : 1;

          // Foreach month in the report
          for (var j = 0; j < reportYears[i].length; j++) {
              
              // Grab the number representation of the month
              var monthActualNumber = parseInt(reportYears[i][j].month);

              // The offset we are currently on 
              var actualOffset = j+offsetStart;

              // What offset should this month be?
              // This depends a little bit on the year, as curYear does NOT have offset 0 be Target, 
              // while prevYear does have Target as first month. Also depends on if the member is on 
              // fiscal year or calendar year.
              var intendedOffset = this.getMonthOffset(monthActualNumber, report.yearStart);

              // console.log(
              //     'Report: '+i+', '+
              //     'Year: '+reportYears[i][j].year+', '+
              //     'Actual Offset: '+actualOffset+', '+
              //     'Intended offset: '+intendedOffset+', '
              // );

              // If the offset we calculated this month should be is greater than the current offset we are 
              // evaluating, then we are missing a month and need to insert a blank to avoid errors in calculations. 
              // Note: we aren't going to worry about the opposite problem of the actual offset being 
              // greater than the intended, because we require that the months be sorted by year,month as a 
              // pre-requisite for this function to work.
              if (intendedOffset > actualOffset) {
                  //console.log('Splicing in new month at offset '+j+' with month value '+(j+offsetStart));
                  // Create an empty month object we can use.
                  var emptyMonth = this.shallowCopy(report.curYear[0], 0);
                  emptyMonth.month = this.getMonthNumber(j+offsetStart, report.yearStart); //j+offsetStart;
                  reportYears[i].splice(j, 0, emptyMonth);
              }
          }
      }

      // Set month if not full year's worth of data.
      report.month = report.curYear.length;

      return report;
  },


  /**
   *  getMonthOffset
   * 
   *  (A general purpose function)
   *  Given an integer representing a month (1-12)
   *  return back an integer representing what offset in the months array that month should be.
   *  Will take into account fiscal year start if month provided.
   * 
   *  In other words, you give this method an month, and it returns the offset that month equates to.
   * 
   *  @param month int The month who's offset you want.
   *  @param yearStart int The month representing the start of the year.
   *  @return A number between 1 and 12.
   */
  this.getMonthOffset = function(month, yearStart)
  {
      if (yearStart == undefined) { yearStart = 1; }
      // 1 ==  ((1-1) + 12) % 12 + 1
      // 1 ==  ((4-4) + 12) % 12 + 1
      // 2 ==  ((5-4) + 12) % 12 + 1
      // 3 ==  ((6-4) + 12) % 12 + 1
      // 12 == ((3-4) + 12) % 12 + 1
      return (((month - yearStart) + 12) %12) + 1;
      //return ((month+(yearStart-2))%12)+1;
  },


  /**
   *  getMonthNumber
   * 
   *  (A general purpose function)
   *  Given an integer representing a month OFFSET (start at 1 for January)
   *  return back an integer representing that number with a padded zero if necessary '01'.
   *  If needing a fiscal year where 1 is representing a month other than January,
   *  the month the fiscal year starts can also be provided as an integer
   *  where 4 = April. In that case getMonthNumber(1,4) would return "04".
   * 
   *  In other words, you give this method an offset, and it returns the month that offset equates to.
   * 
   *  month int The month who's number you want.
   *  yearStart int The month representing the start of the year.
   */
  this.getMonthNumber = function(month, yearStart, pad)
  {
      if (yearStart == undefined) { yearStart = 1; }
      if (pad == undefined) { pad = true; }
      //var month = ((month)+(yearStart-1))%13;
      var month = ((month+(yearStart-2))%12)+1;
      return (month < 10 && pad == true) ? "0" + month : month;
  },
  


  /**
   *  Makes a copy of an object.
   * 
   *  @param original The object to copy.
   *  @param overrideValue A value if you want the new object's properties to all be set to a fixed value.
   */
  this.shallowCopy = function (original = undefined, overrideValue = false) {
    if (!original) {
      return original;
    }
    if (overrideValue == undefined) { overrideValue = false; }
    
    var clone = {};
    var i , keys = Object.keys(original);

    for (i = 0; i < keys.length; i++) {
      // Copy each property into the clone
      clone[keys[i]] = original[keys[i]];
      if (overrideValue !== false) {
        clone[keys[i]] = overrideValue;
      }
    }

    return clone;
  };


}; // end class